module.exports = __webpack_public_path__ + "assets/img/Logitech-VC-1-Article-w960.1b89da37.webp";